"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationIdPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const organizations_service_1 = require("./organizations.service");
let OrganizationIdPipe = class OrganizationIdPipe {
    constructor(_organization) {
        this._organization = _organization;
    }
    transform(value) {
        if (typeof value == 'number') {
            return this._organization.getOrgById(value).displayName;
        }
        else if (typeof value == 'string') {
            return this._organization.getOrgByDisplayName(value).id;
        }
        return value;
    }
};
exports.OrganizationIdPipe = OrganizationIdPipe;
exports.OrganizationIdPipe = OrganizationIdPipe = __decorate([
    (0, core_1.Pipe)({ name: 'organizationId' }),
    __metadata("design:paramtypes", [organizations_service_1.OrganizationsService])
], OrganizationIdPipe);
//# sourceMappingURL=organization-id.pipe.js.map